import React from 'react';
import { DataReconciliationTableHeader } from './components/DataReconciliationTableHeader';
import { TableBody, TableRow, TableWrapper } from '../../CommonComponents/OPL/Table/Table';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { HtmlTable } from '../../CommonComponents/OPL/HtmlTable/HtmlTable';

export const DataReconciliationTableEmpty = () => {
  return (
    <HtmlTable variant="embedded">
      <table>
        <DataReconciliationTableHeader />
        <tbody>
          <tr>
            <Text color="neutral.600">You have not added any accounts.</Text>
          </tr>
        </tbody>
      </table>
    </HtmlTable>
  );
};
